import colormap from 'colormap'

export const getChartColorByIndex = (index: number, nshades = 10): string => {
  return colormap({ colormap: 'jet', nshades: nshades > 8 ? nshades : 9 })[index]
}
